export default function roleFilter(value, roles) {
  return roles.find(item => item.id === value).roleName
}
